import React, { Fragment } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { get, round } from 'lodash'
import { dateFormat, dateVal, moneyColumn, numVal } from '../../../modules/Utils'
import NumberColumn from '../../../elements/Table/Columns/Number'
import { Popconfirm } from 'antd'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../elements/Table/Footers/SumFooter'

function BillLinesList(props) {
  const { billLines, orderType } = props
  let columns = [
    {
      Header: 'No',
      accessor: 'no',
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'UoM',
      accessor: 'uom.code',
    },
    {
      Header: 'Invoicing',
      accessor: 'invoiced',
      Cell: ({ value, original }) => (
        <NumberColumn
          onChange={props.handleChange}
          value={value}
          record={original}
          display={<strong>{moneyColumn(numVal({ value }, 'value'))}</strong>}
          dataIndex={props.keyAttr}
          column={'invoiced'}
          max={original.invoiced || original.unit}
          min={0}
          precision={2}
        />
      ),
    },
    {
      Header: 'Available Units',
      accessor: 'unit',
      Cell: MoneyCell,
    },
    {
      Header: 'Start / End',
      accessor: 'booking',
      width: 200,
      Cell: ({ value, original }) => {
        if (get(original, 'pickup.date')) {
          return `${dateFormat(dateVal(original, 'pickup.date'))} - ${dateFormat(dateVal(original, 'dropoff.date'))}`
        }
        if (get(original, 'billing.start')) {
          return `${dateFormat(dateVal(original, 'billing.start'))} - ${dateFormat(dateVal(original, 'billing.end'))}`
        }
        return ''
      },
    },
    {
      Header: 'Last Billing Period',
      accessor: 'invoicing',
      width: 200,
      Cell: ({ original }) =>
        get(original, 'periodFrom') &&
        `${dateFormat(dateVal(original, 'periodFrom'))} - ${dateFormat(dateVal(original, 'periodTo'))}`,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Tax',
      accessor: 'tax.rate',
      Cell: ({ value, original }) =>
        value
          ? MoneyCell(value)
          : MoneyCell({ value: round((numVal(original, 'tax.percentage') / 100.0) * numVal(original, 'rate')) }),
      Footer: SumFooter,
    },
    {
      Header: 'Total (Net)',
      accessor: 'amount.net',
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Operation',
      accessor: '_id',
      Cell: ({ value, original }) => {
        const { editable } = original
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => props.save(original[props.keyAttr])}>Save</a>
                <span className="ant-divider" />
                <Popconfirm title="Sure to cancel?" onConfirm={() => props.cancel(original[props.keyAttr])}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              <Fragment>
                <a
                  onClick={() => {
                    props.edit(original[props.keyAttr])
                  }}>
                  Edit
                </a>
                <span className="ant-divider" />
                <a onClick={() => props.remove(original[props.keyAttr])}>Remove</a>
              </Fragment>
            )}
          </div>
        )
      },
    },
  ]
  if (['MRO', 'Works'].includes(orderType))
    columns = columns.filter((c) => c.accessor !== 'booking' && c.accessor !== 'invoicing')

  console.log(billLines)
  return (
    <CustomTable
      key={new Date()}
      hide={{ refresh: true }}
      data={billLines}
      columns={columns}
      show={{ extraColumns: true }}
    />
  )
}

BillLinesList.propTypes = {}
BillLinesList.defaultProps = {}

export default BillLinesList
